<template>
  <s-task-list-layout
    :title="$t('PublicServant.Me.AL.DAFConfirmed')"
    back-u-r-l="/tasklist/eDocInternal"
    :is-show-seach-area-prop="filterText !== ''"
    @searchIconClick="searchIconClick"
  >
    <template
      v-slot:search-area
    >
      <s-server-filter-box
        ref="filterBox"
        :placeholder="$t('eDocSuggest.filterBox.hint')"
        :filter-text-prop="filterText"
        @search="search($event)"
      />
    </template>
    <v-skeleton-loader
      v-if="listLoading"
      type="list-item-avatar-two-line, divider, list-item-avatar-two-line"
    />

    <template>
      <s-int-history-list
        :process-data="processData"
        @itemClick="toDetailPage"
      />
    </template>
    <p class="px-4 text-caption grey--text">
      *{{ $t('Workflow.OnlyShowXMonths', {'0': '3'}) }}
    </p>
    <br><br><br><br><br><br>
  </s-task-list-layout>
</template>

<style scoped>
.entity-list-item + .entity-list-item {
  margin-left: 8px;
}
</style>

<script>
import { momentWithHyphen } from '@/utils/datetimeUtil'
import { mapState } from 'vuex'
import { docFlowModule } from '@/store/moduleName'
import STaskListLayout from './components/STaskListLayout'
import { TASK_LIST_JOB_TYPE, DOC_FLOW_STATUS, DOC_FLOW_TYPE, INFLOW_STATUS_CODES } from '@/constant/constant'
// import { globalModule } from '@/store/moduleName'
import { docFlowMethod } from '@/mixins/docFlowMethod'
import docFlowApi from '@/api/eDocInternal/docFlow'
import { mdiEmailEditOutline, mdiClose } from '@mdi/js'
import SIntHistoryList from './components/eDocInternalHistory/SIntHistoryList'
import SServerFilterBox from './components/GeneralList/SServerFilterBox'
import signHelper from '@/helper/signHelper'
import { setStorage } from '@/utils/storageUtil'

export default {
  components: {
    STaskListLayout,
    SIntHistoryList,
    SServerFilterBox
  },
  mixins: [docFlowMethod],
  data: function () {
    return {
      mdiClose: mdiClose,
      mdiEmailEditOutline: mdiEmailEditOutline,
      loading: false,
      dialog: false,
      detailPageObj: null,
      businessCode: '',
      status: [DOC_FLOW_STATUS.PROCESSED, DOC_FLOW_STATUS.CLOSED, DOC_FLOW_STATUS.REDIRECTED],
      jobType: TASK_LIST_JOB_TYPE.MY_JOB
    }
  },
  computed: {
    ...mapState({
      processData: state => state[docFlowModule].processData,
      taskListJobType: state => state[docFlowModule].taskListJobType,
      inflowStatus: state => state[docFlowModule].inflowStatus
    })
  },
  created () {
    if (this.taskListJobType !== this.jobType || this.inflowStatus.length < 2) {
      this.$store.commit(docFlowModule + '/setPageNum', 1)
    }
    this.$store.commit(docFlowModule + '/setTaskListJobType', this.jobType)
    this.$store.commit(docFlowModule + '/setInflowStatus', [INFLOW_STATUS_CODES.ACTIVE, INFLOW_STATUS_CODES.VOID])
    this.$store.commit(docFlowModule + '/setDocFlowType', DOC_FLOW_TYPE.DOC_FLOW)
    this.getProcessList(false, this.filterText, this.status)
    this.uploadFileUrl = docFlowApi.uploadFileUrl
  },
  methods: {
    toDetailPage: function (record) {
      let path = `/tasklist/eDocInternalDetailHistory/${record.dfProcessId}`
      setStorage(signHelper.REDIRECT_PATH, path)
      this.$router.push(path)
      // this.$store.commit(docFlowModule + '/setRedirectPath', path)
    },
    handlePageChange (value) {
      this.pageNum = value
      this.getProcessList(false, this.filterText, this.status)
    },

    momentWithHyphen
  }
}
</script>
